import { SimpleObjectInterface } from '@thewhite/react-global-module/lib/interfaces';
import * as t from 'io-ts';
import BASE_STATUS from '../../Global/enums/baseStatus';

export const OrganizationCategoryType = t.interface({
    id: t.string,
    name: t.union([t.string, t.null, t.undefined]),
    status: t.union([t.string, t.null, t.undefined]),
});

export interface OrganizationCategoryDTO extends t.TypeOf<typeof OrganizationCategoryType> {
}

export class OrganizationCategory {
    id: string;
    name: string | null;
    status: SimpleObjectInterface | null;

    constructor(params: OrganizationCategoryDTO) {
        this.id = params.id;
        this.name = params.name ?? null;
        this.status = params.status
            ? BASE_STATUS[params.status]
            : null;
    }
}
